import React, { useEffect, useState } from 'react'
import Header from '../generals/header'
import Button from 'react-bootstrap/Button'
import styles from '../../css/generals/Checkbox.module.css'
import stylesPreferences from '../../css/preferences/Preferences.module.css'
import { getData, postData } from '../../actions/servicesHttp'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import Swal from 'sweetalert2'
import { popupSimple } from '../generals/popups'
import { useNavigate } from 'react-router-dom'

export default function UpdateLicenses ({ user }) {
  const [inputLicenses, setInputLicenses] = useState(0)
  const [urlServerPreferences] = useState('preferences/server')
  const [urlSynchronizeLicenses] = useState('synchronize-licenses')
  const [urlDownloadActivationCodes] = useState('license-activation-codes')
  const [urlProcessPdf] = useState('process-pdf')
  const { t } = useTranslation('serverPreferences')
  const navigate = useNavigate()

  const getPreferences = async (url, set) => {
    const { data } = await getData(url, 1)

    if (data) {
      // set(data?.max_licences)
      set(data?.max_licenses)
    }
  }

  const synchronizeLicenses = async (route1, route2, set) => {
    Swal.fire({
      title: t('label2'),
      text: t('label3'),
      icon: 'info'
    })

    const res = await postData(route1)

    if (res.status === 200) {
      getPreferences(route2, set)
      return true
    }

    return false
  }

  const handleDownload = async (url, namePdf) => {
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf'
        }
      })

      if (!response.ok) {
        throw new Error('Error al descargar el archivo')
      }

      const blob = await response.blob()
      const blobUrl = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = blobUrl
      link.setAttribute('download', `${namePdf}.pdf`)
      document.body.appendChild(link)
      link.click()
      link.remove()

      window.URL.revokeObjectURL(blobUrl)
    } catch (error) {
      console.error('Error en la descarga:', error)
    }
  }

  const LicenseActivationCodesDownload = async (url1, url2, navigate) => {
    const column = [{ field: 'activationCode', header: t('header') }]
    const colJson = column.map(obj => [obj.header, obj.field])
    const namePdf = t('namePdf')

    popupSimple('info', t('message1'))

    const response = await getData(url1, undefined, navigate)

    if (response?.status === 200) {
      const json = {
        title: namePdf,
        columnName: colJson,
        data: response?.data?.activationCodes
      }

      const res = await postData(url2, json, navigate)
      if (res?.status === 200) {
        handleDownload(res.data.url, namePdf)
      } else {
        popupSimple('error', t('message2'))
      }
    } else {
      popupSimple('error', t('message2'))
    }
  }

  useEffect(() => {
    getPreferences(urlServerPreferences, setInputLicenses)
  }, [user, urlServerPreferences, setInputLicenses])

  return (
        <>
          <Header title={t('title')} margin="0" />
          <div className={`${styles.componentBox} ${stylesPreferences.containerSafeWeb}`}>
                <div className={`${stylesPreferences.containerInputSafeWeb} ${stylesPreferences.containerLicenses}`}>
                    <label className={stylesPreferences.labelPref}>{t('label1')}</label>
                    <input type="number" id="licenses" name="licenses" disabled value={inputLicenses} min={'0'} className={`${stylesPreferences.inputLicenses}`}/>
                </div>
          </div>
          <div className={`${styles.componentBox} ${stylesPreferences.containerSafeWeb}`}>
                <div className={`${stylesPreferences.containerInputSafeWeb} ${stylesPreferences.containerLicenses}`}>
                    <label className={stylesPreferences.labelPref}>{t('label4')}</label>
                    <Button onClick={() => synchronizeLicenses(urlSynchronizeLicenses, urlServerPreferences, setInputLicenses)} variant="dark" className={stylesPreferences.buttonServer}>
                    <i className="fa-solid fa-arrows-rotate" style={{ marginRight: '0.5rem' }}></i>
                    {t('button1')}
                </Button>
                </div>
          </div>
          <div className={`${styles.componentBox} ${stylesPreferences.containerSafeWeb}`}>
                <div className={`${stylesPreferences.containerInputSafeWeb} ${stylesPreferences.containerLicenses}`}>
                    <label className={stylesPreferences.labelPref}>{t('label5')}</label>
                    <Button onClick={() => LicenseActivationCodesDownload(urlDownloadActivationCodes, urlProcessPdf, navigate)} variant="dark" className={stylesPreferences.buttonServer}>
                    <i className="fas fa-download" style={{ marginRight: '0.5rem' }}></i>
                    {t('button2')}
                </Button>
                </div>
          </div>
        </>
  )
}

UpdateLicenses.propTypes = {
  user: PropTypes.object
}
